import React from 'react';

import PageHeader from './Header';
import HeaderCombine from './HeaderCombine';

import { Layout,  Row, Col } from 'antd';
const { Header, Footer, Sider, Content } = Layout;

const ErrorPage = () => (
  <Layout>
    <Header>
      <HeaderCombine showProfile={false}/>
    </Header>

    <Content>
        <div className="error-container">
            <h1>Uh-oh!</h1>
            <h3>Seems like we're having some problems with our data at the moment.</h3>
            <h3>Sorry about that. We're currently investigating the issue and it will be back online ASAP.</h3>
        </div>
    </Content>
  </Layout>

);

export default ErrorPage;



// WEBPACK FOOTER //
// ./src/components/ErrorPage.js